import { useEffect, useState } from "react";
import { selectAccountData } from "../../redux/main/accountSlice";
import CustomSelectElement from "../CustomSelectElement";
import { useSelector } from 'react-redux';
import { useColorPalette } from "../../hooks/useColorPalette"; // Importa il custom hook

export default function ListPagination({ children, initTotalElements, onPageChange }) {
    const paramsInitialState = {
        totalElements: null,
        pageSize: 10,
        totalPages: 10,
        selectedPage: 1,
        from: 0,
        to: 24
    }
    // Imposto ed eseguo la chiamata iniziale
    const accountData = useSelector(selectAccountData);
    const palette = useColorPalette(); // Usa l'hook per ottenere la palette
    const token = localStorage.getItem('installamelo-auth-token') || '';

    // Gestisco i click di cambio pagina ed eseguo ogni volta una nuova chiamata
    const [params, setParams] = useState(paramsInitialState);
    // Imposto la quantità di elementi iniziali
    useEffect(() => {
        if (initTotalElements) {
            setParams(prevState => ({
                ...prevState,
                totalElements: initTotalElements,
                totalPages: Math.ceil(initTotalElements / params.pageSize)
            }))
        }
    }, [initTotalElements])
    const handlePageClick = (increment) => {
        if (params.totalElements) {
            let newPage = 1;

            if (typeof increment === 'string') {
                if (increment === 'first') newPage = 1;
                else if (increment === 'last') newPage = params.totalPages;
                else newPage = params.selectedPage; // Default per stringhe non riconosciute
            } else {
                newPage = params.selectedPage + increment;
                // Mi assicuro che newPage sia nei limiti
                newPage = Math.max(1, Math.min(newPage, params.totalPages));
            }

            const from = (newPage - 1) * params.pageSize;
            const to = Math.min(from + params.pageSize, params.totalElements);

            setParams(prevState => {
                return {
                    ...prevState,
                    selectedPage: newPage,
                    from,
                    to
                };
            });

            // Chiamo la funzione del genitore con i nuovi valori
            onPageChange(from, params.pageSize);
        }
    };
    const handleSetPageSize = (newSize, label) => {
        const fixedNewSite = Number(newSize)
        if (params.totalElements) {
            const newTotalPages = Math.ceil((params.totalElements) / fixedNewSite);
            const newSelectedPage = 1; // Torna alla prima pagina quando cambia la dimensione
            const newFrom = 0; // Inizia dalla prima pagina
            const newTo = Math.min(fixedNewSite, params.totalElements);

            setParams(prevState => {
                return {
                    ...prevState,
                    pageSize: newSize,
                    totalPages: newTotalPages,
                    selectedPage: newSelectedPage,
                    from: newFrom,
                    to: newTo
                };
            });

            // Chiamo la funzione del genitore con i nuovi valori
            onPageChange(newFrom, newSize);
        }
    };
    return (
        <div>
            {/* BARRA DI RICERCA E IMPOSTAZIONE ELEMENTI PER PAGINA */}
            <div className="my-4 flex justify-between p-4 flex items-center">

                {/* Spazio riservato - Input di ricerca rimosso */}
                <div className="flex items-center">
                    {/* Contenuto rimosso */}
                </div>

                {/* Selezione length */}
                <div className="text-slate-300 flex items-center">
                    <CustomSelectElement
                        id="pageSize"
                        name="pageSize"
                        list={[{ label: "10", value: 10 }, { label: "25", value: 25 }, { label: "50", value: 50 }, { label: "100", value: 100 }]}
                        setter={handleSetPageSize}
                        defaultValue={paramsInitialState.pageSize} />
                </div>

            </div>
            {children}

            {/* SELEZIONE PAGINE */}
            <div className="mt-4 w-full p-4 flex justify-between items-center">
                <div className="text-slate-400">Vista da {params?.from} a {params?.to} di {params.totalElements} elementi</div>
                <div className="flex gap-4">
                    {/* PRECEDENTE */}
                    {
                        params.selectedPage > 1 ? (
                            <button key="prev-active" style={{ backgroundColor: palette.secondary, color: palette.textOnSecondary, padding: '8px 16px', borderRadius: '4px' }} onClick={() => handlePageClick(-1)}>Precedente</button>
                        ) : (
                            <button key="prev-disabled" className="disabled">Precedente</button>
                        )
                    }
                    <div className="flex gap-2">
                        {/* Vai alla prima pagina */}
                        {params.selectedPage > 3 && <button key="first-page" style={{ backgroundColor: palette.secondary, color: palette.textOnSecondary, padding: '8px', borderRadius: '4px', width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => handlePageClick('first')}>1</button>}
                        {params.selectedPage > 3 && <span key="first-ellipsis" className="flex items-center">...</span>}
                        {params.selectedPage > 2 && <button key={`page-${params.selectedPage-2}`} style={{ backgroundColor: palette.secondary, color: palette.textOnSecondary, padding: '8px', borderRadius: '4px', width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => handlePageClick(-2)}>{params.selectedPage - 2}</button>}
                        {params.selectedPage > 1 && <button key={`page-${params.selectedPage-1}`} style={{ backgroundColor: palette.secondary, color: palette.textOnSecondary, padding: '8px', borderRadius: '4px', width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => handlePageClick(-1)}>{params.selectedPage - 1}</button>}
                        <button key={`page-${params.selectedPage}`} style={{ backgroundColor: palette.primary, color: palette.textOnPrimary, padding: '8px', borderRadius: '4px', width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'default' }}>{params.selectedPage}</button>
                        {params.totalElements && params.selectedPage < (params.totalPages) && <button key={`page-${params.selectedPage+1}`} style={{ backgroundColor: palette.secondary, color: palette.textOnSecondary, padding: '8px', borderRadius: '4px', width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => handlePageClick(+1)}>{params.selectedPage + 1}</button>}
                        {params.totalElements && params.selectedPage < (params.totalPages - 1) && <button key={`page-${params.selectedPage+2}`} style={{ backgroundColor: palette.secondary, color: palette.textOnSecondary, padding: '8px', borderRadius: '4px', width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => handlePageClick(+2)}>{params.selectedPage + 2}</button>}
                        {params.totalElements && params.selectedPage < (params.totalPages - 2) && <span key="last-ellipsis" className="flex items-center">...</span>}
                        {/* Vai all'ultima pagina */}
                        {params.selectedPage < (params.totalPages - 2) && <button key="last-page" style={{ backgroundColor: palette.secondary, color: palette.textOnSecondary, padding: '8px', borderRadius: '4px', width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => handlePageClick('last')}>{params.totalPages}</button>}
                    </div>
                    {/* SUCCESSIVO */}
                    {
                        params.selectedPage === params.totalPages ? (
                            <button key="next-disabled" className="disabled">Successivo</button>
                        ) : (
                            <button key="next-button" style={{ backgroundColor: palette.secondary, color: palette.textOnSecondary, padding: '8px 16px', borderRadius: '4px' }} onClick={() => handlePageClick(+1)}>Successivo</button>
                        )
                    }
                </div>
            </div>
        </div >

    )
}